import { render, staticRenderFns } from "./r-modal-window.vue?vue&type=template&id=24e599b8&scoped=true"
import script from "./r-modal-window.vue?vue&type=script&setup=true&lang=js"
export * from "./r-modal-window.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-modal-window.vue?vue&type=style&index=0&id=24e599b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e599b8",
  null
  
)

export default component.exports